import { render, staticRenderFns } from "./AllCountryGreetings.vue?vue&type=template&id=5686d656&scoped=true&"
import script from "./AllCountryGreetings.vue?vue&type=script&lang=js&"
export * from "./AllCountryGreetings.vue?vue&type=script&lang=js&"
import style0 from "./AllCountryGreetings.vue?vue&type=style&index=0&id=5686d656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5686d656",
  null
  
)

export default component.exports